module.exports = __webpack_public_path__ + "static/media/HCMM909.6a58cd53.jpg";